import script from "./SignInMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInMain.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__